export default class OrganizationTree {
    constructor (parentId, id, level, name, organizationCounter = 0, fleetsCounter = 0, devicesCounter = 0, vehicleCounter = 0) {
        this.parentId = parentId
        this.organizations = []
        this.fleets = []
        this.devices = []
        this.id = id
        this.level = level
        this.name = name
        this.type = 'Organization'
        this.parent = null
        this.organizationCounter = organizationCounter
        this.fleetsCounter = fleetsCounter
        this.devicesCounter = devicesCounter
        this.vehicleCounter = vehicleCounter
        this.items = []
        this.isChanged = false
        this.isExpanded = false
    }

    setParent (parent) {
        this.parent = parent
    }

    setOrganizations (organizations) {
        this.organizations = organizations
        this.organizationCounter = this.organizations.length

        this.generateItems()
    }

    setFleets (fleets) {
        this.fleets = fleets
        this.fleetsCounter = this.fleets.length

        this.generateItems()
    }

    setDevices (devices) {
        this.devices = devices
        this.devicesCounter = this.devices.length

        this.generateItems()
    }

    generateItems () {
        this.items = [
            ...this.organizations || [],
            ...this.fleets || [],
            ...this.devices || []
        ]
    }
}
